import { IGatewaysContext } from "./GatewaysContext.inteface";
import { createContext } from "react";

export const GatewaysContext = createContext<IGatewaysContext>(
  {} as IGatewaysContext
);
